import RestService from "./RestService";

export default class PVTransferService extends RestService {
  constructor() {
    super("/api/pvtransfer");
  }
}
